
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/buyUProductOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'
import {
  getExchangeOrderList,
  getExchangeStatistics,
  getExchangeSonInfo,
  getExchangeDetail,
} from '@/api/order/exchangeOrder'
import { Form as ElForm } from 'element-ui'
import { notifiedStatusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import { checkNeedAudit, checkPermission } from '@/utils/permission'
import { getCurrentDate, dateToSeconds } from '@/utils/dateTime'
import { getAccountGroupList } from '@/api/product/accountGroup'
import { getType } from '@/utils/cookies'
import exchangeSonOrder from './components/exchangeSonOrder.vue'

@Component({
  name: 'depositList',
  components: {
    exchangeSonOrder,
  },
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  queryForm: any = {
    order_number: null,
    child_ordernumber: null,
    merchant_no: null,
    ant_username: null,
    remarks: null,
    upstream_status: null,
    product_name: null,
    product_account_name: null,
    product_account_group: null,
    status: null,
    start_time: null,
    end_time: null,
    notify_status: null,
    wallet_address: null,
    success_start_time: null,
    success_end_time: null,
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private statusList: any[] = []
  private notifiedStatusList = notifiedStatusList
  private instruction: any[] = []
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private totalData: any = {}
  // private total = {}
  private total = 0

  private dialogVisible: boolean = false
  private setForm: any = {}
  private payTime: any = ''
  private selectList: any[] = []
  private ordernumbers: any[] = []

  private loading: boolean = false

  private currentOrdernumber: number | null = null
  private fixTime: any = null
  private sysType: any = ''

  // 跳转地址
  private jumpAddress(row, type) {
    if (type === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row}/transfers`)
    } else if (type === 'erc20') {
      window.open(`https://etherscan.io/address/${row}`)
    }
  }
  private hashJump(row) {
    if (row.product_account_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.product_account_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      delObjEmptyKey(data)
      this.orderList = []
      await getExchangeOrderList(data).then((res: any) => {
        this.orderList = res.results
        this.orderList.forEach((item: any) => {
          this.$set(item, 'subOrderList', [])
          if (this.expandedRows.indexOf(item.ordernumber) !== -1) {
            this.getWithdrawInfo(item)
          }
        })
        this.listLoading = false
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private handleSelectionChange(list) {
    this.selectList = list
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private reset() {
    this.queryForm = {
      order_number: null,
      child_ordernumber: null,
      merchant_no: null,
      ant_username: null,
      remarks: null,
      upstream_status: null,
      product_name: null,
      product_account_name: null,
      product_account_group: null,
      status: null,
      start_time: null,
      end_time: null,
      notify_status: null,
      wallet_address: null,
      success_start_time: null,
      success_end_time: null,
      currency: this.queryForm.currency,
    }
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.notifyDate = getCurrentDate()
    this.successDate = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.depositOrderStatistical()
    })
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  // 入金订单统计
  private async depositOrderStatistical() {
    try {
      let data: any = {
        ...this.queryForm,
      }
      delObjEmptyKey(data)
      await getExchangeStatistics(data).then((res: any) => {
        this.totalData = res
        console.log(this.totalData, 'kkk')
      })
    } catch (e) {}
  }
  private queryName: any = ''
  private productNameChange() {
    this.queryForm.product_account_group = ''
    this.getProductAccountGroup(this.queryName)
  }

  private expandedRows: any[] = []
  private async expandChange(row, expandedRows) {
    this.expandedRows = expandedRows.map((item) => item.ordernumber)
    if (expandedRows.length > 0) {
      await this.getWithdrawInfo(row)
    }
  }
  private async getWithdrawInfo(row: any) {
    await getExchangeSonInfo(row.ordernumber).then((res: any) => {
      row.subOrderList = res
    })
  }

  // 远程查询 inProductList
  private accountGroupList: any[] = []
  private async getProductAccountGroup(query: string) {
    this.queryName = query
    try {
      const data = {
        product_code: this.queryForm.product_code,
        name: query,
        page_size: 50,
      }
      await getAccountGroupList(data).then((res: any) => {
        this.accountGroupList = res.results
      })
    } catch (e) {}
  }

  // 打开弹框
  private drawer: boolean = false
  private exchangeInfo: any = {}
  private openDrawer(row: any) {
    this.exchangeInfo = row
    this.drawer = true
  }
  private closeDrawer() {
    this.drawer = false
  }

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    // await AppModule.GetConstant().then((res: any) => {
    //   this.statusList = res.IN_ORDER_STATUS_CHOICES
    // })
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    ;(window as any).jumpAddress = this.jumpAddress
    this.init()
    this.sysType = getType()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.exchangeOrder`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
